"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("../../auth");
/**
 * Esegue la richiesta solo se il token è stato validato dal server
 * (non controlla se è scaduto)
 *
 * @export
 * @class TokenVerified
 */
class TokenVerified {
    constructor(data) {
        return new Promise(resolve => {
            auth_1.Auth.verified(() => resolve(data));
        });
    }
}
exports.default = TokenVerified;
